import type { RefType } from '../types';

const baseCopy = [
    {
        title: '会員資格',
        content: [
            {
                subtitle: 'エコポイント特典プログラムは、どのようなものですか。',
                text: 'エコポイント特典プログラムは、ポイントに基づくプログラム制度で、当社のお客様は、ecoflow.com（Amazon、楽天、Yahooなど第三者または小売業者は除く）でのお買い物に応じてポイントを獲得することができます。また、獲得したポイントは、特典と交換することが可能です。',
            },
            {
                subtitle: 'エコポイント特典プログラムには、どのようにして参加できますか。',
                text: 'すでにecoflow.comでのアカウントをお持ちの方は、ご自分のアカウントにログインしてください。\necoflow.comでのアカウントお持ちでない方は、まずアカウントの新規登録を行ってください。登録の手順は<a href="https://jp.ecoflow.com/pages/rewards-guide">こちら</a>でご覧いただけます。ポイントを獲得するには、会員登録が必須となりますのでご了承ください。',
            },
            {
                subtitle: 'このプログラムの参加は無料ですか。',
                text: '当社の特典プログラムは一切費用がかかりません。登録後はすぐにポイント獲得が可能です。',
            },
            {
                subtitle: '特典およびポイントに金銭的価値はありますか。',
                text: 'エコポイント特典プログラムによって獲得した特典およびポイントには金銭的価値はなく、第三者に譲渡することはできません。',
            },
            {
                subtitle: 'EcoFlowアカウントを2つ持っているのですが、これを1つにまとめることはできますか。',
                text: 'いいえ、できません。異なる会員が異なるアカウントで貯めたポイントは、商品を購入したり、その他のいかなる理由であっても、組み合わせるまたは合算することはできません。',
            },
            {
                subtitle: '交換可能な自分のポイントをどこで確認できますか。',
                text: 'ガイドで手順をご参照の上、ご自分のエコポイント残高を確認してください。',
            },
        ],
    },
    {
        title: 'ポイントを獲得する',
        content: [
            {
                subtitle: 'ポイントはどこで獲得できますか。',
                text: 'ecoflow.comおよびEcoFlowアプリ上でポイントを獲得できます。会員は、購入の時点、またはその他の特典対象となるアクションを行う際に、EcoFlowアカウントにログインしている必要があります。',
            },
            {
                subtitle: 'ポイントはいつ受け取れますか。',
                text: 'ポイントは通常、24時間以内にお客様のアカウントに付与されます。ecoflow.comでのご購入については、注文商品が出荷されるまでお客様のアカウントにポイントが付与されるのを待っている状態となります。なお、付与が完了していないポイントは交換できません。',
            },
            {
                subtitle: 'ポイントが自分のアカウントに正しく付与されなかった場合は、どうすればよいですか。',
                text: 'ご自分のエコポイント会員アカウントに関してご質問がある場合は、support.jp@ecoflow.comのカスタマーサービスまでお問い合わせください。',
            },
            {
                subtitle: 'ポイントは失効しますか。',
                text: 'はい。当社の会員特典プログラムが正式に開始された日（2022年11月4日）より前に獲得したポイントは、その開始日の1年後に失効します。当社のプログラムの開始日より後に獲得したポイントは、ポイント獲得日の1年後に失効します。失効したポイントは、お客様のアカウントから差し引かれます。',
            },
            {
                subtitle: 'エコポイント特典プログラムが開始される前に行った過去の取引に対してポイントを獲得することはできますか?',
                text: 'はい。当社のエコポイント特典プログラムが正式に開始された2022年11月4日より前に決済を行った注文に対するポイントは、その購入の時点でお客様がご自分のEcoFlowアカウントにログインしていた場合、お客様のアカウントに付与されています。それらのポイントは1年後に失効します。ただし、お客様がエコポイント会員になる前に行った購入については、ポイントは付与されません。',
            },
            {
                subtitle: 'ポイントの獲得方法を教えてください。',
                text: 'お客様は、下記の時にエコポイントを獲得します。\n1. アカウント新規登録時。登録の際に1回に限りポイントが付与されます。\n2. ご自分のプロフィールの設定完了時。プロフィール、写真およびアドレスの入力を完了すると、初回に限りポイントを獲得します。その後に修正を繰り返した場合は、ポイント付与の対象とはなりません。\n3. お客様が購入した商品が発送されたとき。\n4. 公式サイトでお客様の商品の保証登録を行ったとき。お客様が登録を完了するたびにポイントが付与されます。登録に必要なシリアルナンバーが不正確である場合、ポイントは付与されません。',
            },
            {
                subtitle: '消費税や配送料も特典付与の対象ですか。',
                text: 'いいえ。会員が支払う配送料と消費税等の税金は、ポイントの計算には含まれません。',
            },
            {
                subtitle: '割引またはギフトカードについてポイントは付与されますか。',
                text: '商品またはサービスに関連して提供された割引、その他の請求減額分については、ポイントを獲得することはできません。',
            },
            {
                subtitle: '返品または注文の取り消しをした場合、ポイントはどうなりますか。',
                text: '商品を返品した場合、または注文を取り消した場合、お客様が当該購入によって受け取ったポイントは取り消し、または減算されます。価格調整による一部返金の場合にも、ポイントは差し引かれます。',
            },
        ],
    },
    {
        title: 'ポイントを交換する',
        content: [
            {
                subtitle: 'エコポイントを特典に交換するにはどうしたらいいですか？',
                text: 'エコポイントのアカウントにログインし、「エコポイント特典を利用する」部分に移動します。特典を選び、「今すぐ交換する」をクリックします。その後、発送フォームに必要事項を記入し、送信してください。',
            },
            {
                subtitle: '交換した特典の配送状況を知るにはどうしたらいいですか？',
                text: '1. 「私の実績 」部分で、交換した特典の注文番号を確認します。注文番号をクリックして「マイ アカウント」ページに移動し、特典の配達状況を追跡します。\n2. 特典に交換後、確認メールが届きます。交換した特典が発送されると、追跡番号を記載した発送通知メールが届きます。\n3. <a href="https://jp.ecoflow.com/pages/track-order">https://jp.ecoflow.com/pages/track-order</a> にアクセスして、注文番号または追跡番号を入力し、詳細をご確認ください。',
            },
            {
                subtitle: '交換した特典の送料を払う必要はありますか？',
                text: 'ほとんどの場合、交換した特典の送料は無料ですが、一部の特典については送料をご負担いただく場合があります。',
            },
            {
                subtitle: '交換した特典のキャンセルや返品はできますか？',
                text: 'いいえ、できません。特典と交換する前に再確認をしてください。交換した特典が破損して到着した場合は、7日以内にカスタマーサービス <a href="mailto:hello.jp@ecoflow.com">hello.jp@ecoflow.com</a>までご連絡ください。',
            },
            {
                subtitle: '交換した特典は、エコフローで購入した製品と同梱できますか？',
                text: 'いいえ、できません。交換した特典はご購入いただいた製品とは別に発送されます。',
            },
            {
                subtitle: '交換した特典の発送日を指定することはできますか？',
                text: 'いいえ、できません。特典は交換が確認された時点で発送されます。',
            },
            {
                subtitle: "知りたいことがここに記載していない場合は、どこに連絡すればよいでしょうか？",
                text: 'カスタマーサービス<a href="mailto:hello.jp@ecoflow.com">hello.jp@ecoflow.com</a>までメールでお問合せください。',
            },
            {
                subtitle: 'ギフトカードについて質問がある場合は、どこに連絡すればいいでしょうか？',
                text: 'エコフローギフトカードの利用規約については、弊社カスタマーサービスにご相談ください。\nその他のギフトカードについては、そのギフトカードの発行元の会社にお問い合わせください。',
            },
            {
                subtitle: '使用済みの割引コードまたはギフトカードを取り戻すことはできますか。',
                text: 'いいえ。使用済みの特典は、再度使用するために取り戻すことや取り消すことはできません。',
            },
        ],
    },
    {
        title: 'PLUS会員について',
        content: [
            {
                subtitle: 'PLUS 会員になるためにはどのような条件がありますか？また、PLUS 会員と会員の違いは何ですか？',
                text: "EcoFlow では、EcoFlow をご愛顧いただいている皆さまへの感謝の気持ちを込めて、エコポイント特典プログラムを創設しました。会員の皆様には、充実した特典、優れたサービス、最新情報をご提供しています。2024 年の初めには会員数が 100 万人を突破したことから、100 万人の会員の皆さまにさらなるサポートを提供するために、エコポイント特典をアップグレードすることになりました。\n\nアカウントに 6,000 エコポイントをお持ちの場合は、完全無料で PLUS 会員にアップグレードできます。会員向けのすべての特典をはじめ、PLUS 会員限定の割引や特典をご利用いただけます。\n\nすべてが 1 つになった信頼性の高いメンバーシップサービスは、100 万人の会員の皆さまだけにご用意したサービスです。アップグレードされたプレミアムな PLUS 特典で、よりお得に、そしてより安心して、この柔軟なエネルギーの未来をご体験いただけます。\n\n",
            },
            {
                subtitle: 'PLUS 会員のステータスに有効期限はありますか？',
                text: 'はい、 有効期限は 1 年間です。\nエコポイントの残高が 6,000 未満の場合、会員から PLUS 会員にアップグレードした 1 年後に PLUS 会員のステータスが失効します。アカウントに 6,000 以上のエコポイントをお持ちであれば、PLUS 会員のステータスを保持することができます。\n',
            },
            {
                subtitle: 'エコポイントを現金差し引き、あるいは割引券やギフトと交換に使用した場合、PLUS 会員のステータスは変わりますか？',
                text: "ご安心ください。有効期間内であれば、エコポイントの現金差し引き、または割引券やギフトと交換に使用しても、PLUS 会員のステータスは保持されます。多くのタスクを完了し、より多くのエコポイントを獲得して、ステータスを保持しましょう。",
            },
            {
                subtitle: 'PLUS 会員として受けられる特別な割引には、どのようなものがありますか？',
                text: 'PLUS 会員になると、以下のような割引が提供されます。\n- お誕生日のお買い物分のポイントが2倍になります。\n- PLUS会員限定特典（*累計60万円以上（税込み）のお買い物をされたPLUS会員限定、会員資格につき一度のみ入手可能）',
            },
            {
                subtitle: 'PLUS 会員にはどのようなサービスメリットがありますか？',
                text: 'PLUS 会員になると、メンバーシップ期間中は以下のようなサービスをご利用いただけます。\n\n6 ヵ月間の不良品交換：交換期間を合計 6 ヵ月に延長し、故障した製品を新しい製品と交換することができます。\n\n特別なカスタマーサービス：PLUS 会員としての活動を通じて、優先的に継続的なカスタマーサービスサポートを受けることができます。',
            },
            {
                subtitle: 'その他にどのような体験ができますか？',
                text: 'EcoFlow の新製品リリース時には、「新製品のお試し使用イベント」にアクセスすることができます。今後追加される特典にもご期待ください。',
            },
        ],
    },
];
const accountings: { key: string; ref: RefType }[] = [
    {
        key: 'default',
        ref: baseCopy,
    },
];

const getJpCopy = (key: string) => {
    const [data] = accountings.filter((item) => item.key === key);
    const copies: RefType = data?.ref || baseCopy;
    return copies.map((item, ind) => ({ ...item, key: ind }));
};

export default getJpCopy;
